"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fixedUserfields = void 0;
exports.fixedUserfields = [
    {
        name: "firstName",
        label: "First Name",
        type: "text",
        sortable: true,
        showInApp: true,
        showInSummary: true,
        fixed: true,
        filterable: true,
    },
    {
        name: "lastName",
        label: "Last Name",
        type: "text",
        sortable: false,
        showInApp: false,
        showInSummary: true,
        fixed: true,
        readOnly: true,
        filterable: false,
    },
    {
        name: "email",
        label: "Email",
        type: "text",
        sortable: false,
        showInApp: false,
        showInSummary: true,
        fixed: true,
        readOnly: true,
        filterable: false,
    },
    {
        name: "mobile",
        label: "Mobile No.",
        type: "number",
        sortable: false,
        showInApp: true,
        showInSummary: true,
        fixed: true,
        filterable: false,
    },
    {
        name: "role",
        label: "Role",
        type: "text",
        sortable: false,
        showInApp: false,
        showInSummary: false,
        fixed: true,
        filterable: true,
    },
    {
        name: "expiredAt",
        label: "Expire(MM/DD/YYYY, hh:mm:ss)",
        type: "date",
        sortable: false,
        showInApp: false,
        showInSummary: false,
        fixed: true,
        filterable: true,
    },
    {
        name: "activatedAt",
        label: "Active(MM/DD/YYYY, hh:mm:ss)",
        type: "date",
        sortable: false,
        showInApp: false,
        showInSummary: false,
        fixed: true,
        filterable: true,
    }
];
//# sourceMappingURL=User.js.map